import script from "./AssistantWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssistantWindow.vue?vue&type=script&setup=true&lang=ts"

import "./AssistantWindow.vue?vue&type=style&index=0&id=154a282c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154a282c"]])

export default __exports__